<template>
  <div>
    <!-- แถบ config -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          ตั้งค่าโบนัสแนะนำเพื่อน
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-2">
            <b-col cols="12">
              <b-button @click="modal_config()" v-b-modal.modal-config variant="btn-primary" class="btn bg-gradient-primary waves-effect waves-light"><span><feather-icon icon="PlusIcon" /></span> สร้างการตั้งค่า</b-button>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive :fields="fields_aff" :items="items_aff" :filter="filter_aff" :filter-included-fields="filterOn_aff" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(dp_bonus_type)="data">
                  {{ data.value == true ? 'ฝากครั้งแรก' : 'ทุกยอดฝาก' }}
                </template>
                <template #cell(dp_bonus)="data">
                  {{ data.value }} %
                </template>
                <template #cell(winlose_bonus)="data">
                  {{ data.value }} %
                </template>
                <template #cell(commision_bonus)="data">
                  {{ data.value }} %
                </template>
                <template #cell(recieve_mode)="data">
                  {{ data.value == 1 ? 'รายวัน' : data.value == 2 ? 'รายสัปดาห์' : 'รายเดือน' }}
                </template>
                <template #cell(enable)="data">
                  <span :class="data.value == true ? 'badge badge-success' : 'badge badge-danger'">{{ data.value == true ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}</span>
                </template>
                <template #cell(manage)="data">
                  <div class="btn-group">
                    <b-dropdown variant="link" toggle-class="bg-gradient-success waves-effect waves-light">
                      <template #button-content>
                        <span><feather-icon icon="EditIcon" class="font-medium-1 mr-1" /></span>จัดการ
                      </template>
                      <b-dropdown-item @click="modal_config(data.item)" v-b-modal.modal-config><span><feather-icon icon="EditIcon" class="text-warning mr-1" /></span>แก้ไข</b-dropdown-item>
                      <b-dropdown-divider v-if="data.item.id != 0"></b-dropdown-divider>
                      <b-dropdown-item v-if="data.item.id != 0" @click="remove(data.item)"><span><feather-icon icon="TrashIcon" class="text-danger mr-1" /></span>ลบ</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
          <!-- Table Footer -->
          <b-row>
            <b-col sm="12" md="5">
              <div role="status" aria-live="polite">แสดง 1 ถึง {{ items_aff.length }} จาก {{func.toNum(items_aff.length)}} รายการ</div>
            </b-col>
            <b-col sm="12" md="7">
              <b-pagination
                v-on:change="onPageChange"
                v-model="currentPage"
                :total-rows="items_aff.length"
                :per-page="perPage"
                align="end"
                size="sm"
                class="my-0"
                :first-number="true"
                :last-number="true"
              >
                <template #prev-text>‹ ย้อนกลับ</template>
                <template #next-text>ถัดไป ›</template>
              </b-pagination>
            </b-col>
          </b-row>
          <!-- End Table Footer -->
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบ config -->
    <!-- แถบ user -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          เลือก Username เพื่อดูการตั้งค่าปัจจุบันของ ลูกค้า
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-2">
            <b-col cols="md-3 col-sm-6">
              <v-select v-model="selected_user" :options="option_users" label="title" combobox-class="form-control" placeholder="เลือก Username">
                <template #option="{ title, full_name }">
                  {{ title }} ({{ full_name }})
                </template>
              </v-select>
            </b-col>
            <b-col cols="md-3 col-sm-6">
              <b-button variant="btn-primary" @click="fetch_user()" class="btn bg-gradient-primary waves-effect waves-light">ค้นหา</b-button>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive :fields="fields_aff" :items="items_aff.slice(0, 1)" :filter="filter_aff" :filter-included-fields="filterOn_aff" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(dp_bonus_type)="data">
                  {{ data.value == true ? 'ฝากครั้งแรก' : 'ทุกยอดฝาก' }}
                </template>
                <template #cell(dp_bonus)="data">
                  {{ data.value }} %
                </template>
                <template #cell(winlose_bonus)="data">
                  {{ data.value }} %
                </template>
                <template #cell(commision_bonus)="data">
                  {{ data.value }} %
                </template>
                <template #cell(recieve_mode)="data">
                  {{ data.value == 1 ? 'รายวัน' : data.value == 2 ? 'รายสัปดาห์' : 'รายเดือน' }}
                </template>
                <template #cell(enable)="data">
                  <span :class="data.value == true ? 'badge badge-success' : 'badge badge-danger'">{{ data.value == true ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}</span>
                </template>
                <template #cell(manage)="data">
                  <div class="btn-group">
                    <b-dropdown variant="link" toggle-class="bg-gradient-success waves-effect waves-light">
                      <template #button-content>
                        <span><feather-icon icon="EditIcon" class="font-medium-1 mr-1" /></span>จัดการ
                      </template>
                      <b-dropdown-item ><span><feather-icon icon="EditIcon" class="text-warning mr-1" /></span>แก้ไข</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
        </b-card-body>
      </div>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          รายละเอียดรายได้
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <b-row>
            <b-col cols="12 col-md-4" class="p-1">
              <div class="p-2 card-child shadow">
                รายได้วันนี้
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-4" class="p-1">
              <div class="p-2 card-child shadow">
                รายได้ปัจจุบันที่ยังไม่ได้รับ
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-4" class="p-1">
              <div class="p-2 card-child shadow">
                รายสะสมได้ที่รับไปเเล้ว
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </div>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          Link Affiliate
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <b-row>
            <b-col cols="12 col-md-12" class="p-1">
              <div class="p-2 card-child shadow">
                Link Affiliate
                <hr class="solid">
                <div class="d-flex" style="justify-content: space-between;">
                  <div class="pt-1">
                    /?id=1
                  </div>
                  <div class="pt-1">
                    <button type="button" class="btn btn-sm bg-gradient-primary waves-effect waves-light text-white"><span><feather-icon icon="CopyIcon" class="font-medium-1 mr-1" /></span>copy</button>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-4" class="p-1">
              <div class="p-2 card-child shadow">
                จำนวนคนเปิดลิงก์ทั้งหมด
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-4" class="p-1">
              <div class="p-2 card-child shadow">
                จำนวนคนสมัคร
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-4" class="p-1">
              <div class="p-2 card-child shadow">
                จำนวนคนสมัคร และมีการฝาก
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </div>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          Downline
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <b-row>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                จำนวน downline ทั้งหมด
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                จำนวน downline ติดตัว ทั้งหมด
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                จำนวน ชั้น ของสายลึกที่มีทั้งหมด
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                ยอดฝาก downline วันนี้
                <hr class="solid">
                <div class="text-end">
                  0
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                ยอดฝาก downline สะสม
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                รายได้ ยอดฝาก downline สะสม
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                รายได้ ยอดเสีย downline สะสม
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
            <b-col cols="12 col-md-3" class="p-1">
              <div class="p-2 card-child shadow">
                รายได้ ยอดคอมมิชชั่น downline สะสม
                <hr class="solid">
                <div class="text-end">
                  0.00
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบ user -->
    <!-- แถบ aff member -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          รายการแนะนำเพื่อน ของสมาชิก {{ selected_username }}
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-1">
            <b-col cols="12 col-md-6" class="pr-1 pl-1">
              <div>
                <b-input-group>

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_start_report"> วันที่ (จาก) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_start_report" id="date_start_report" class="form-control text-center" />

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_end_report"> วันที่ (ถึง) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_end_report" id="date_end_report" class="form-control text-center" />

                </b-input-group>
              </div>
            </b-col>
            <b-col cols="12 col-md-2">
              <div class="btn-group">
                <b-button @click="fetch()" variant="btn-primary" class="btn bg-gradient-primary waves-effect waves-light"> ค้นหา </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Header -->
          <b-row>
            <b-col md="3" sm="2" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">แสดง</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" v-on:change="onPageSelect" style="width: 60px"/>
                <label class="d-inline-block text-sm-right ml-50">รายการ</label>
              </b-form-group>
            </b-col>
            <b-col md="5" sm="6" class="my-1" />
            <b-col md="4" sm="4" class="my-1">
              <b-form-group label="ค้นหา :" label-cols-sm="6" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0" >
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" v-on:change="onPageSelect" type="search" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"> ล้าง </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- End Table Header -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive :fields="fields" :items="items" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(no)="data">
                  {{ data.index + 1}}
                </template>
                <template #cell(to_account_username)="data">
                  <div class="text-left">{{data.item.full_name}} ({{ data.item.to_account_username }})</div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
          <!-- Table Footer -->
          <b-row>
            <b-col sm="12" md="5">
              <div role="status" aria-live="polite">แสดง {{ func.show_page(perPage, currentPage) }} ถึง {{ func.show_page_to(perPage, currentPage, recordsTotal) }} จาก {{func.toNum(totalRows)}} รายการ (ค้นหา จากทั้งหมด {{perPage}} รายการ)</div>
            </b-col>
            <b-col sm="12" md="7">
              <b-pagination
                v-on:change="onPageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="end"
                size="sm"
                class="my-0"
                :first-number="true"
                :last-number="true"
              >
                <template #prev-text>‹ ย้อนกลับ</template>
                <template #next-text>ถัดไป ›</template>
              </b-pagination>
            </b-col>
          </b-row>
          <!-- End Table Footer -->
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบ aff member -->
    <!-- แถบ downline deposit member -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          รายการฝาก downline ของสมาชิก {{ selected_username }}
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-1">
            <b-col cols="12 col-md-6" class="pr-1 pl-1">
              <div>
                <b-input-group>

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_start_report"> วันที่ (จาก) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_start_report" id="date_start_report" class="form-control text-center" />

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_end_report"> วันที่ (ถึง) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_end_report" id="date_end_report" class="form-control text-center" />

                </b-input-group>
              </div>
            </b-col>
            <b-col cols="12 col-md-2">
              <div class="btn-group">
                <b-button @click="fetch()" variant="btn-primary" class="btn bg-gradient-primary waves-effect waves-light"> ค้นหา </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Header -->
          <b-row>
            <b-col md="3" sm="2" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">แสดง</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" v-on:change="onPageSelect" style="width: 60px"/>
                <label class="d-inline-block text-sm-right ml-50">รายการ</label>
              </b-form-group>
            </b-col>
            <b-col md="5" sm="6" class="my-1" />
            <b-col md="4" sm="4" class="my-1">
              <b-form-group label="ค้นหา :" label-cols-sm="6" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0" >
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" v-on:change="onPageSelect" type="search" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"> ล้าง </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- End Table Header -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive :fields="fields_deposit" :items="items_deposit" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(no)="data">
                  {{ data.index + 1}}
                </template>
                <template #cell(cal_dp_status)="data">
                  <span v-if="data.value" class="text-success">success</span>
                  <span v-else class="secondary">calculating</span>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
          <!-- Table Footer -->
          <b-row>
            <b-col sm="12" md="5">
              <div role="status" aria-live="polite">แสดง {{ func.show_page(perPage, currentPage) }} ถึง {{ func.show_page_to(perPage, currentPage, recordsTotal) }} จาก {{func.toNum(totalRows)}} รายการ (ค้นหา จากทั้งหมด {{perPage}} รายการ)</div>
            </b-col>
            <b-col sm="12" md="7">
              <b-pagination
                v-on:change="onPageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="end"
                size="sm"
                class="my-0"
                :first-number="true"
                :last-number="true"
              >
                <template #prev-text>‹ ย้อนกลับ</template>
                <template #next-text>ถัดไป ›</template>
              </b-pagination>
            </b-col>
          </b-row>
          <!-- End Table Footer -->
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบ downline deposit member -->
    <!-- แถบ bonus commission member -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          รายการโบนัสยอดเสีย และ โบนัส Commission downline ของสมาชิก {{ selected_username }}
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-1">
            <b-col cols="12 col-md-6" class="pr-1 pl-1">
              <div>
                <b-input-group>

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_start_report"> วันที่ (จาก) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_start_report" id="date_start_report" class="form-control text-center" />

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_end_report"> วันที่ (ถึง) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_end_report" id="date_end_report" class="form-control text-center" />

                </b-input-group>
              </div>
            </b-col>
            <b-col cols="12 col-md-2">
              <div class="btn-group">
                <b-button @click="fetch()" variant="btn-primary" class="btn bg-gradient-primary waves-effect waves-light"> ค้นหา </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Header -->
          <b-row>
            <b-col md="3" sm="2" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">แสดง</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" v-on:change="onPageSelect" style="width: 60px"/>
                <label class="d-inline-block text-sm-right ml-50">รายการ</label>
              </b-form-group>
            </b-col>
            <b-col md="5" sm="6" class="my-1" />
            <b-col md="4" sm="4" class="my-1">
              <b-form-group label="ค้นหา :" label-cols-sm="6" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0" >
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" v-on:change="onPageSelect" type="search" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"> ล้าง </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- End Table Header -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive :fields="fields_bonus" :items="items_bonus" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(no)="data">
                  {{ data.index + 1}}
                </template>
                <template #cell(aff_bonus)="data">
                  <span v-if="data.value >= 0" class="text-success"><strong>{{ data.value }}</strong></span>
                  <span v-if="data.value < 0" class="text-danger"><strong>{{ data.value }}</strong></span>
                </template>
                <template #cell(type)="data">
                  <span v-if="data.value == 0" class="badge badge-success"><strong>โบนัสยอดฝาก</strong></span>
                  <span v-if="data.value == 1" class="badge badge-primary"><strong>โบนัสยอดเสีย</strong></span>
                  <span v-if="data.value == 2" class="badge badge-danger"><strong>โบนัส commission</strong></span>
                </template>
                <template #cell(recieved)="data">
                  <span>{{ data.value ? 'รับแล้ว' : 'ยังไม่ได้รับ' }}</span>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
          <!-- Table Footer -->
          <b-row>
            <b-col sm="12" md="5">
              <div role="status" aria-live="polite">แสดง {{ func.show_page(perPage, currentPage) }} ถึง {{ func.show_page_to(perPage, currentPage, recordsTotal) }} จาก {{func.toNum(totalRows)}} รายการ (ค้นหา จากทั้งหมด {{perPage}} รายการ)</div>
            </b-col>
            <b-col sm="12" md="7">
              <b-pagination
                v-on:change="onPageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="end"
                size="sm"
                class="my-0"
                :first-number="true"
                :last-number="true"
              >
                <template #prev-text>‹ ย้อนกลับ</template>
                <template #next-text>ถัดไป ›</template>
              </b-pagination>
            </b-col>
          </b-row>
          <!-- End Table Footer -->
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบ bonus commission member -->
    
    <b-modal
      id="modal-config"
      centered
      title="สร้างการตั้งค่า สายงาน"
      ok-only
      ok-title="ตกลง"
      ok-variant=" bg-gradient-primary waves-effect waves-light"
      @ok="update_config()"
    >
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="สายงาน:"
        label-for="input-config_name"
      >
        <b-form-input
          id="input-config_name"
          v-model="config.config_name"
          placeholder="ชื่อสายงาน"
          :disabled="config.id == 0"
        />
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="โบนัสยอดฝาก(%):"
        label-for="input-dp_bonus"
      >
        <b-form-input
          id="input-dp_bonus"
          v-model="config.dp_bonus"
          placeholder="โบนัสยอดฝาก(%)"
          type="number"
        />
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="โบนัสยอดเสีย(%):"
        label-for="input-winlose_bonus"
      >
        <b-form-input
          id="input-winlose_bonus"
          v-model="config.winlose_bonus"
          placeholder="โบนัสยอดเสีย(%)"
          type="number"
        />
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="โบนัส Turnover(%):"
        label-for="input-commision_bonus"
      >
        <b-form-input
          id="input-commision_bonus"
          v-model="config.commision_bonus"
          placeholder="โบนัส Turnover(%)"
          type="number"
        />
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="การรับรายได้:"
        label-for="input-enable"
      >
        <b-button 
          variant="btn-primary" 
          :class="{ 'bg-gradient-success': config.recieve_mode == 1, 'bg-gradient-info': config.recieve_mode == 2, 'bg-gradient-primary': config.recieve_mode == 3 }" 
          class="btn waves-effect waves-light" 
          style="width: 120px"
          @click="toggleRecieve()"
        >
          {{ config.recieve_mode == 1 ? 'รายวัน' : config.recieve_mode == 2 ? 'รายสัปดาห์' : 'รายเดือน' }}
        </b-button>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="ประเภท:"
        label-for="input-enable"
      >
        <b-button 
          variant="btn-primary" 
          :class="{ 'bg-gradient-success': config.dp_bonus_type, 'bg-gradient-primary': !config.dp_bonus_type }" 
          class="btn waves-effect waves-light" 
          style="width: 120px"
          @click="toggleType()"
        >
          {{ config.dp_bonus_type ? 'ฝากครั้งแรก' : 'ทุกยอดฝาก' }}
        </b-button>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="4"
        label="สถานะ:"
        label-for="input-enable"
      >
        <b-button 
          variant="btn-primary" 
          :class="{ 'bg-gradient-success': config.enable, 'bg-gradient-danger': !config.enable }" 
          class="btn waves-effect waves-light" 
          style="width: 120px"
          @click="toggleEnable()"
        >
          {{ config.enable ? 'อนุญาต' : 'ไม่อนุญาต' }}
        </b-button>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCol, BRow, BTable, BInputGroup, BInputGroupPrepend, BFormInput, BButton, BFormGroup, BInputGroupAppend, BFormSelect,
  BPagination, BDropdown, BDropdownItem, BDropdownDivider,
  BModal, VBModal, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import func from '@core/comp-functions/misc/func'

export default {
  components: {
    BCard, BCardHeader, BCardBody,
    BCol, BRow, BTable,
    BInputGroup, BInputGroupPrepend, BFormInput, BFormGroup, BInputGroupAppend,
    BButton, BModal,
    BFormSelect,
    BPagination,
    BDropdown, BDropdownItem, BDropdownDivider,
    vSelect,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      func: func,
      BASE_URL: process.env.BASE_URL,
      date_start_report: '',
      date_end_report: '',
      selected: { title: 'ทั้งหมด', value: '' },
      option: [
        { title: 'ทั้งหมด', value: '' },
      ],
      config: {
        config_name: '',
        dp_bonus: 0,
        winlose_bonus: 0,
        commision_bonus: 0,
        recieve_mode: 1,
        dp_bonus_type: true,
        enable: true,
      },
      config_copy: {},
      selected_user: { title: 'เลือก Username', id: '' },
      selected_username: '',
      option_users: [],
      draw: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 50,
      currentPage: 5,
      recordsTotal: 0,
      filter: '',
      filterOn: [],
      fields: [
        { key: 'no', label: 'No.', class: 'text-center' },
        { key: 'prefix', label: 'PREFIX', class: 'text-center' },
        { key: 'to_account_username', label: 'username', class: 'text-center' },
        { key: 'created_at', label: 'วันที่สมัคร', class: 'text-center' },
      ],
      items: [],
      fields_deposit: [
        { key: 'no', label: 'No.', class: 'text-center' },
        { key: 'self_username', label: 'username', class: 'text-center' },
        { key: 'amount', label: 'ยอดฝาก', class: 'text-center' },
        { key: 'cal_dp_status', label: 'สถานะการคำนวน', class: 'text-center' },
        { key: 'start_cal_time', label: 'วันที่ฝาก', class: 'text-center' },
      ],
      items_deposit: [],
      fields_bonus: [
        { key: 'no', label: 'No.', class: 'text-center' },
        { key: 'child_username', label: 'username', class: 'text-center' },
        { key: 'aff_bonus', label: 'โบนัสที่ได้	', class: 'text-center' },
        { key: 'type', label: 'รูปแบบโบนัส', class: 'text-center' },
        { key: 'turnover', label: 'turnover', class: 'text-center' },
        { key: 'date', label: 'คำนวนประจำวันที่', class: 'text-center' },
        { key: 'web_profit', label: 'กำไรของเว็บ', class: 'text-center' },
        { key: 'recieved', label: 'รับรายได้', class: 'text-center' },
      ],
      items_bonus: [],
      filter_aff: '',
      filterOn_aff: [],
      fields_aff: [
        { key: 'no', label: 'No.', class: 'text-center' },
        { key: 'config_name', label: 'สายงาน', class: 'text-center text-nowrap' },
        { key: 'dp_bonus_type', label: 'ประเภท', class: 'text-center text-nowrap' },
        { key: 'dp_bonus', label: 'โบนัสยอดฝาก', class: 'text-center text-nowrap' },
        { key: 'winlose_bonus', label: 'โบนัสยอดเสีย', class: 'text-center text-nowrap' },
        { key: 'commision_bonus', label: 'โบนัส Turnover', class: 'text-center text-nowrap' },
        { key: 'recieve_mode', label: 'การรับรายได้', class: 'text-center text-nowrap' },
        { key: 'enable', label: 'สถานะ', class: 'text-center text-nowrap' },
        { key: 'created_at', label: 'วันที่สร้าง', class: 'text-center text-nowrap' },
        { key: 'create_by', label: 'สร้างโดย', class: 'text-center text-nowrap' },
        { key: 'manage', label: 'จัดการข้อมูล', class: 'text-center' },
      ],
      items_aff: [],
      t_fetch: 0,
      bank_list: JSON.parse('{"01":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","02":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","03":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","04":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","05":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","06":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","07":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","08":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","09":"\u0e18.\u0e01.\u0e2a.","1":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","2":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","3":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","4":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","5":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","6":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","7":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","8":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","9":"\u0e18.\u0e01.\u0e2a."}'),
    }
  },
  mounted() {
    this.totalRows = this.items.length
    this.fetch_config()
    this.fetch_username()
    this.config_copy = this.config
  },
  watch: {
    filter: {
      handler() {
        this.fetch()
        this.totalRows = this.items.length
        this.currentPage = 1
      },
    }
  },
  methods: {
    modal_config(item) {
      if (item != null)
        this.config = item
      else
        this.config = this.config_copy
    },
    toggleType() {
      this.config.dp_bonus_type = !this.config.dp_bonus_type
    },
    toggleEnable() {
      this.config.enable = !this.config.enable
    },
    toggleRecieve() {
      this.config.recieve_mode++
      if (this.config.recieve_mode > 3)
        this.config.recieve_mode = 1
    },
    onFiltered(filteredItems) {
      // this.totalRows = filteredItems.length
      // this.currentPage = 1
    },
    onPageSelect() {
      let start = this.perPage * (this.currentPage - 1)
      this.fetch(start)
    },
    onPageChange(page) {
      let start = this.perPage * (page - 1)
      this.fetch(start)
    },
    loading() {
      this.$swal({
			  text: "กรุณารอสักครู่..",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: '',
        willOpen: () => {
          this.$swal.showLoading()
        },
      });
    },
    success(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'success',
        confirmButtonText: 'เรียบร้อย',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    warn(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    error(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'error',
        confirmButtonText: 'ตกลง',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    load(data) {
      if (data == null || data.data == null) return;
      this.draw = data.draw
      this.items = data.data
      this.totalRows = data.recordsFiltered
      this.recordsTotal = data.recordsTotal
    },
    fetch(start=0) {
      let url = `ref/ref_list_page?draw=${this.draw}&start=${start}&length=${this.perPage}&search%5Bvalue%5D=${this.filter}&prefix=${this.selected.value}&date_start=${this.date_start_report}&date_end=${this.date_end_report}&status=&_=${Date.now()}`;
      this.$http.get(url).then(res => { this.load(res.data) })
    },
    fetch_user() {
      if (!this.selected_user.title.includes('เลือก')) {
        this.selected_username = this.selected_user.title;
        this.filter = this.selected_user.title;
      }
      this.fetch();
    },
    fetch_config() {
      let url = `ref/aff_list_page?draw=${this.draw}`;
      this.$http.get(url).then(res => { this.items_aff = res.data.data })
    },
    fetch_username() {
      this.$http.get('credit/username').then(res => { res.data.forEach(data=> this.option_users.push({title: data.account_agent_username !== '' ? data.account_agent_username : data.full_name , id: data.id, full_name: data.full_name })) })
    },
    update_config() {
      let data = this.config;
      let url = 'ref/aff_update/' + data.id;
      let text = 'ยืนยันการแก้ไขข้อมูล ' + data.config_name;
      if (data.id == undefined) {
        url = 'ref/aff_create';
        text = 'ยืนยันการสร้างข้อมูล ' + data.config_name;
      }
      this.$swal({
        icon: 'warning',
        title: 'แจ้งเตือน',
        text: text,
        confirmButtonText: 'ตกลง',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary mr-1',
        },
        buttonsStyling: false,
      }).then((res) => {
        if (res.value) {
          this.loading()
          this.$http.post(url, data).then((res) => {
            this.$swal.close()
            if (res.data.data) {
              this.success(res.data.message)
              this.fetch_config()
            } else {
              this.error('ทำรายการไม่สำเร็จ')
              this.fetch_config()
            }
          })
        }
      })
    },
    remove(e) {
      let data = {
        id: e.id,
        config_name: e.config_name
      }
      this.$swal({
        icon: 'warning',
        title: 'แจ้งเตือน',
        text: 'ยืนยันการลบข้อมูล ' + data.config_name,
        confirmButtonText: 'ตกลง',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary mr-1',
        },
        buttonsStyling: false,
      }).then((res) => {
        if (res.value) {
          this.loading()
          this.$http.post('ref/aff_delete/' + data.id).then((res) => {
            this.$swal.close()
            if (res.data.result) {
              this.success(res.data.message)
              this.fetch_config()
            } else {
              this.error('ทำรายการไม่สำเร็จ')
              this.fetch_config()
            }
          })
        }
      })
    },
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.t_fetch)
    next()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
body.dark-layout.swal2-toast-shown .swal2-container.swal2-top{background-color: #283046}
body.swal2-toast-shown .swal2-container{background-color: transparent}body.swal2-toast-shown .swal2-container.swal2-shown{background-color: transparent}body.swal2-toast-shown .swal2-container.swal2-top{top: 0;right: auto;bottom: auto;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top: 0;right: 0;bottom: auto;left: auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top: 0;right: auto;bottom: auto;left: 0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top: 50%;right: auto;bottom: auto;left: 0;-webkit-transform: translateY(-50%);transform: translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top: 50%;right: auto;bottom: auto;left: 50%;-webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top: 50%;right: 0;bottom: auto;left: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top: auto;right: auto;bottom: 0;left: 0}body.swal2-toast-shown .swal2-container.swal2-bottom{top: auto;right: auto;bottom: 0;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top: auto;right: 0;bottom: 0;left: auto}body.swal2-toast-column .swal2-toast{flex-direction: column;align-items: stretch}body.swal2-toast-column .swal2-toast .swal2-actions{flex: 1;align-self: stretch;height: 2.2em;margin-top: 0.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{justify-content: center}body.swal2-toast-column .swal2-toast .swal2-input{height: 2em;margin: 0.3125em auto;font-size: 1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size: 1em}.swal2-popup.swal2-toast{flex-direction: row;align-items: center;width: auto;padding: 0.625em;box-shadow: 0 0 0.625em #d9d9d9;overflow-y: hidden}.swal2-popup.swal2-toast .swal2-header{flex-direction: row}.swal2-popup.swal2-toast .swal2-title{flex-grow: 1;justify-content: flex-start;margin: 0 0.6em;font-size: 1em}.swal2-popup.swal2-toast .swal2-footer{margin: 0.5em 0 0;padding: 0.5em 0 0;font-size: 0.8em}.swal2-popup.swal2-toast .swal2-close{position: initial;width: 0.8em;height: 0.8em;line-height: 0.8}.swal2-popup.swal2-toast .swal2-content{justify-content: flex-start;font-size: 1em}.swal2-popup.swal2-toast .swal2-icon{width: 2em;min-width: 2em;height: 2em;margin: 0}.swal2-popup.swal2-toast .swal2-icon-text{font-size: 2em;font-weight: 700;line-height: 1em}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width: 2em;height: 2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^="swal2-x-mark-line"]{top: 0.875em;width: 1.375em}.swal2-popup.swal2-toast.swal2-icon.swal2-error[class^="swal2-x-mark-line"][class$="left"]{left: 0.3125em}.swal2-popup.swal2-toast.swal2-icon.swal2-error[class^="swal2-x-mark-line"][class$="right"]{right: 0.3125em}.swal2-popup.swal2-toast .swal2-actions{height: auto;margin: 0 0.3125em}.swal2-popup.swal2-toast .swal2-styled{margin: 0 0.3125em;padding: 0.3125em 0.625em;font-size: 1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow: 0 0 0 0.0625em #fff, 0 0 0 0.125em rgba(50, 100, 150, 0.4)}.swal2-popup.swal2-toast .swal2-success{border-color: #a5dc86}.swal2-popup.swal2-toast .swal2-success [class^="swal2-success-circular-line"]{position: absolute;width: 2em;height: 2.8125em;-webkit-transform: rotate(45deg);transform: rotate(45deg);border-radius: 50%}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-circular-line"][class$="left"]{top: -0.25em;left: -0.9375em;-webkit-transform: rotate(-45deg);transform: rotate(-45deg);-webkit-transform-origin: 2em 2em;transform-origin: 2em 2em;border-radius: 4em 0 0 4em}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-circular-line"][class$="right"]{top: -0.25em;left: 0.9375em;-webkit-transform-origin: 0 2em;transform-origin: 0 2em;border-radius: 0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width: 2em;height: 2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top: 0;left: 0.4375em;width: 0.4375em;height: 2.6875em}.swal2-popup.swal2-toast .swal2-success [class^="swal2-success-line"]{height: 0.3125em}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-line"][class$="tip"]{top: 1.125em;left: 0.1875em;width: 0.75em}.swal2-popup.swal2-toast.swal2-success[class^="swal2-success-line"][class$="long"]{top: 0.9375em;right: 0.1875em;width: 1.375em}.swal2-popup.swal2-toast.swal2-show{-webkit-animation: showSweetToast 0.5s;animation: showSweetToast 0.5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation: hideSweetToast 0.2s forwards;animation: hideSweetToast 0.2s forwards}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation: animate-toast-success-tip 0.75s;animation: animate-toast-success-tip 0.75s}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long{-webkit-animation: animate-toast-success-long 0.75s;animation: animate-toast-success-long 0.75s}@-webkit-keyframes showSweetToast{0%{-webkit-transform: translateY(-0.625em) rotateZ(2deg);transform: translateY(-0.625em) rotateZ(2deg);opacity: 0}33%{-webkit-transform: translateY(0) rotateZ(-2deg);transform: translateY(0) rotateZ(-2deg);opacity: 0.5}66%{-webkit-transform: translateY(0.3125em) rotateZ(2deg);transform: translateY(0.3125em) rotateZ(2deg);opacity: 0.7}100%{-webkit-transform: translateY(0) rotateZ(0);transform: translateY(0) rotateZ(0);opacity: 1}}@keyframes showSweetToast{0%{-webkit-transform: translateY(-0.625em) rotateZ(2deg);transform: translateY(-0.625em) rotateZ(2deg);opacity: 0}33%{-webkit-transform: translateY(0) rotateZ(-2deg);transform: translateY(0) rotateZ(-2deg);opacity: 0.5}66%{-webkit-transform: translateY(0.3125em) rotateZ(2deg);transform: translateY(0.3125em) rotateZ(2deg);opacity: 0.7}100%{-webkit-transform: translateY(0) rotateZ(0);transform: translateY(0) rotateZ(0);opacity: 1}}@-webkit-keyframes hideSweetToast{0%{opacity: 1}33%{opacity: 0.5}100%{-webkit-transform: rotateZ(1deg);transform: rotateZ(1deg);opacity: 0}}@keyframes hideSweetToast{0%{opacity: 1}33%{opacity: 0.5}100%{-webkit-transform: rotateZ(1deg);transform: rotateZ(1deg);opacity: 0}}@-webkit-keyframes animate-toast-success-tip{0%{top: 0.5625em;left: 0.0625em;width: 0}54%{top: 0.125em;left: 0.125em;width: 0}70%{top: 0.625em;left: -0.25em;width: 1.625em}84%{top: 1.0625em;left: 0.75em;width: 0.5em}100%{top: 1.125em;left: 0.1875em;width: 0.75em}}@keyframes animate-toast-success-tip{0%{top: 0.5625em;left: 0.0625em;width: 0}54%{top: 0.125em;left: 0.125em;width: 0}70%{top: 0.625em;left: -0.25em;width: 1.625em}84%{top: 1.0625em;left: 0.75em;width: 0.5em}100%{top: 1.125em;left: 0.1875em;width: 0.75em}}@-webkit-keyframes animate-toast-success-long{0%{top: 1.625em;right: 1.375em;width: 0}65%{top: 1.25em;right: 0.9375em;width: 0}84%{top: 0.9375em;right: 0;width: 1.125em}100%{top: 0.9375em;right: 0.1875em;width: 1.375em}}@keyframes animate-toast-success-long{0%{top: 1.625em;right: 1.375em;width: 0}65%{top: 1.25em;right: 0.9375em;width: 0}84%{top: 0.9375em;right: 0;width: 1.125em}100%{top: 0.9375em;right: 0.1875em;width: 1.375em}}
.vs__dropdown-toggle, .vs__dropdown-toggle:hover { border-top-left-radius: 0; border-bottom-left-radius: 0; }
</style>
